import brands from "./brands";
import categories from "./categories";
import codes from "./codes";
import coupons from "./coupons";
import deliveries from "./deliveries";
import displays from "./displays";
import exhibitions from "./exhibitions";
import inquires from "./inquires";
import invoices from "./invoices";
import islands from "./islands";
import orders from "./orders";
import products from "./products";
import purchases from "./purchases";
import reviews from "./reviews";
import shippings from "./shippings";

export default {
    brands,
    categories,
    codes,
    coupons,
    deliveries,
    displays,
    exhibitions,
    inquires,
    invoices,
    islands,
    orders,
    products,
    purchases,
    reviews,
    shippings,
};
